var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.params.data.url,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.params.data.filename)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }